import React, {useEffect, useState} from "react";
import {Col, Row, Card, Form} from "react-bootstrap";
import Logo from "../assets/images/logo.svg"
import mfa from "../assets/json/mfa.json"
import {useNavigate} from "react-router-dom";
import LoginImage from "../components/LoginImage";
import {ACCESS_TOKEN, INITIAL_TOKEN, INITIAL_TOKEN_STAGE_MFA} from "../constants";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../components/Loader";
import useAuthPublicPagesRedirect from "../hooks/auth/useAuthPublicPagesRedirect";
import {mfaTrust} from "../actions/LoginActions";

function MultifactorAuthentication() {
    const history = useNavigate();
    const dispatch = useDispatch();
    const [verificationType, setVerificationType] = useState();
    const [disableSubmit, setDisableSubmit] = useState(true);

    const mfaTrustOtpData = useSelector(state => state.mfaTrustOtp);
    const {loadingMfaTrust, mfaTrustData, errorMfaTrust} = mfaTrustOtpData;

    useAuthPublicPagesRedirect(INITIAL_TOKEN_STAGE_MFA);

    const selectMfaType = (data) => {
        return data.map((item) =>
            (<div>
                <Form.Check
                    name="mfa"
                    label={item.data}
                    type="radio"
                    id={item.id}
                    onClick={() => setMfaType(item.type)}
                />
            </div>)
        );
    }

    const setMfaType = (type) => {
        setDisableSubmit(false);
        setVerificationType(type)
    };

    const submitHandler = (event) => {
        event.preventDefault();

        dispatch(mfaTrust(verificationType, history));
    };

    useEffect(() => {
        if (mfaTrustData?.token) {
            const token = mfaTrustData?.token;

            if (!token) {
                return;
            }

            localStorage.setItem(INITIAL_TOKEN, JSON.stringify(token));

            history("/client")
        }
    }, [mfaTrustOtpData]);

    return (
        <Row className="login-background">
            {loadingMfaTrust && <Loader/>}
            {errorMfaTrust && <div className="error-message">
                <div className="d-inline message-1 ms-1">{errorMfaTrust}</div>
            </div>}
            <Col lg={{span: 4, offset: 1}} md={{span: 4, offset: 1}}>
                <Card className="card-body">
                    <img src={Logo} alt="logo" className="logo"/>
                    <form className="margin-top">
                        <p className="header">Multi-factor Authentication</p>
                        <p className="sub-header">How often do you want to authenticate when signing into the app?</p>
                        {selectMfaType(mfa)}
                        <div className="login-button">
                            <button
                                onClick={submitHandler}
                                disabled={disableSubmit}
                                type="submit"
                                className={`button-solid ${disableSubmit ? "button-inactive" : "button-active"} `}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                    <div className="copyright">
                        <p className="sub-footer">v2.0</p>
                        <p className="sub-footer">copyright text</p>
                    </div>
                </Card>
            </Col>
            <Col lg={{span: 7, offset: 0}} md={{span: 7, offset: 0}}>
                <LoginImage/>
            </Col>
        </Row>
    );
}

export default MultifactorAuthentication;